import {
  BackgroundColor,
  FareCardSkeleton,
  FareInfographicsMosaic
} from "@silversea-ssc/ui-components-react";
import React from "react";
import { fareByPriority, fareContentByFareCodes } from "src/utils/fares";
import FareCard from "./FareCard/FareCard";
import { extractFareCardHeaderContent } from "./FareCard/utils";
import { isPresent } from "src/utils/checks";
import { UseFetchDataResponse } from "src/ssc-api/useFetchApi";
import { CruiseGroupV2ApiResponse } from "@silversea-ssc/dotcom-api-types/CruiseGroup";
import { InfographicBoxContentFragment } from "types/graphql-types";
import { CruiseGroupCode } from "@silversea-ssc/web-cruise-groups";
import { dequal } from "dequal";

type Props = {
  cruiseGroupRemoteData: UseFetchDataResponse<CruiseGroupV2ApiResponse>;
  faresContent: (InfographicBoxContentFragment & {
    fareCodes?: (string | undefined)[];
  })[];
  cruiseGroup: CruiseGroupCode;
  topBackgroundColor: BackgroundColor | undefined;
  bottomBackgroundColor: BackgroundColor | undefined;
};

const CruiseGroupFaresMosaic: React.FC<Props> = ({
  cruiseGroupRemoteData,
  faresContent,
  cruiseGroup,
  topBackgroundColor,
  bottomBackgroundColor
}) => {
  const orderedRemoteData = (cruiseGroupRemoteData.data?.fares || [])
    .filter(isPresent)
    .sort((a, b) => fareByPriority(a.fareCode, b.fareCode));

  return (
    <FareInfographicsMosaic
      topBackgroundColor={topBackgroundColor}
      bottomBackgroundColor={bottomBackgroundColor}
    >
      {cruiseGroupRemoteData.isLoading
        ? [0, 1, 2].map((i) => (
            <FareCardSkeleton key={i} expandable={true} isExpanded={true} />
          ))
        : orderedRemoteData.map((remoteCruiseGroup) => {
            const fareContent = fareContentByFareCodes(
              faresContent,
              remoteCruiseGroup.fareCode
            );
            return (
              <FareCard
                {...extractFareCardHeaderContent(fareContent)}
                key={remoteCruiseGroup.fareCode}
                fareCode={remoteCruiseGroup.fareCode}
                enabledInclusions={remoteCruiseGroup.inclusions}
                cruiseGroup={cruiseGroup}
                inclusionsContentTokens={remoteCruiseGroup.tokenValues}
                variant="expanded"
              />
            );
          })}
    </FareInfographicsMosaic>
  );
};

export default React.memo(CruiseGroupFaresMosaic, dequal);
